import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { api } from '../services/api';
import { Platform } from '../types';
import { useNavigate } from 'react-router-dom';

export default function DashboardPage() {
  const { user, signOut } = useAuthStore();
  const navigate = useNavigate();
  const [platforms, setPlatforms] = useState<Platform[]>([]);
  const [tempEmail, setTempEmail] = useState<string | null>(null);

  useEffect(() => {
    // This is a placeholder. The real logic would fetch from the API.
    // api.get('/platforms').then(res => setPlatforms(res.data));
    setTempEmail('user-temp-mail@10minutemail.com');
  }, []);

  const handleStartSetup = () => {
    navigate('/platforms');
  };

  return (
    <div className="container mx-auto p-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Welcome, {user?.email}</h1>
        <button onClick={signOut} className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded">
          Sign Out
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Your Temporary Email</h2>
          <p className="text-gray-400">{tempEmail || 'Not generated yet'}</p>
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Account Status</h2>
          <p className="text-green-400">Active</p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <h2 className="text-2xl font-semibold mb-4">Ready to Start Earning?</h2>
        <p className="text-gray-400 mb-6">Select CAPTCHA platforms and configure your payout settings.</p>
        <button onClick={handleStartSetup} className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg text-lg">
          Start Platform Setup
        </button>
      </div>
    </div>
  );
}
